import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import {
  showMedicalRecord,
  pdfGeneratorStatus,
} from "../../actions/medicalRecords";
import { PDFExport } from "@progress/kendo-react-pdf";
import HeaderTemplate from "../../pages/medical-records/view/header.js";
import { BASE_URL } from "../../utils/helper";

async function toDataURL(src, callback) {
  var img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    var canvas = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    var dataURL;
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL("image/png");
    callback(dataURL);
  };

  let imgscr = src + "?t=" + Math.floor(Math.random() * 10000);

  img.src = imgscr;
  if (img.complete || img.complete === undefined) {
    img.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = imgscr;
  }
}

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return [match[2], '-', match[3], '-', match[4]].join('')
  }
  return ""
}

class DOPDFView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    mRecord: {
      Breed: {},
      Pet: {},
      Registration_type: {},
      Breeder: {},
      MedicalRecordMedications: [],
    },
    bannerDone: "",
    signatureDone: "",
    sending: false,
    filename: "-waybill.pdf"
  };

  componentDidMount() {
    this.props.setClick(this.exportPDF);
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.medicalRecordsReducer.printMRecord &&
      this.props.data.medicalRecordsReducer.printMRecord !==
        nextProps.data.medicalRecordsReducer.printMRecord
    ) {
      this.setState({
        mRecord: nextProps.data.medicalRecordsReducer.printMRecord,
      });
    }
  };

  exportPDF = async () => {
    var _self = this;
    _self.props.pdfGeneratorStatus(true);

    _self.path =
      process.env.REACT_APP_S3_PATH +
      "/" +
      this.props.petShop.currentPetshop.logo_path;
      if(this.props.petShop.currentPetshop.logo_path){
        toDataURL(_self.path, async function (dataUrl) {
          _self.setState({ sending: false });
          _self.setState({ bannerDone: dataUrl });
    
          try {
           await _self.props.pdfGeneratorStatus(false);
           _self.exportSignaturePDF();
            
          } catch (e) {
            console.error("Problem", e);
          }
        });
      }else{
        try {
          await _self.props.pdfGeneratorStatus(false);
          _self.exportSignaturePDF();
        } catch (e) {
          console.error("Problem", e);
        }
      }
  };

  exportSignaturePDF = async () => {
    var _self = this;
    _self.props.pdfGeneratorStatus(true);

    _self.path =
      process.env.REACT_APP_S3_PATH +
      "/" +
      this.props.data.medicalRecordsReducer.printMRecord.Breeder.signature_path;
      if(this.props.data.medicalRecordsReducer.printMRecord.Breeder.signature_path){
        toDataURL(_self.path, async function (dataUrl) {
          _self.setState({ sending: false });
          _self.setState({ signatureDone: dataUrl });
    
          try {
            await _self.resume.save();
            _self.props.pdfGeneratorStatus(false);
          } catch (e) {
            console.error("Problem", e);
          }
        });
      }else{
        try {
          await _self.resume.save();
          _self.props.pdfGeneratorStatus(false);
        } catch (e) {
          console.error("Problem", e);
        }
      }
    //
  };

  formatVaccinations(mRecord){

    let html = "";

    let htmlheadWithBoder = `<div style="padding: 5px 5px 5px 10px;width: 50%;border-right: 1px solid rgb(197, 197, 197);min-height: 190px;">
    <table>
      <thead>
        <tr>
          <th>DATE(S)</th>
          <th style="padding: 0 10px 0 10px;">VACCINATIONS</th>
        </tr>
      </thead>
      <tbody>`
    
    let htmlheadWithoutBoder = `<div style="padding: 5px 5px 5px 10px;width: 50%;min-height: 190px;">
      <table>
        <thead>
          <tr>
            <th>DATE(S)</th>
            <th style="padding: 0 10px 0 10px;">VACCINATIONS</th>
          </tr>
        </thead>
        <tbody>`  

      

    let htmlbot = `</tbody>
        </table>   
      </div>`

    let vaccine = mRecord.MedicalRecordMedications.filter(
      (i) => {
        return i.Medication.type === "vaccine";
      }
    )

    if(vaccine.length <= 10){
      html += htmlheadWithBoder 
      vaccine.map((item, index) => (
        html  += `<tr>
          <td>
            ${item.date}
          </td>
          <td style="padding: 0 10px 0 10px;">
            ${item.Medication.name} - ${item.more_info}
          </td>
        </tr>`
      ))
      html += htmlbot;

      html += htmlheadWithoutBoder;
      html += htmlbot;
    }else{

      
      let i = 1;
      let continues = 1;
      let temp_html = ``;
      let divider = Math.ceil(vaccine.length / 2);

      vaccine.map((item, index) => {
        if(i == 1){
          if(continues == 1){
            temp_html += htmlheadWithBoder;
          }else{
            temp_html += htmlheadWithoutBoder;
          }
        }

        temp_html  += `<tr>
          <td>
            ${item.date}
          </td>
          <td style="padding: 0 10px 0 10px;">
            ${item.Medication.name} - ${item.more_info}
          </td>
        </tr>`

        if(i == 10 || (index+1) == vaccine.length){
          temp_html += htmlbot;
          html += temp_html
          temp_html = "";
          i = 1;
          
        }else{
          i++;
        }

        continues++;

      });

    }

    return html;
  }

  formatTreatments(mRecord){

    let html = "";
    
    let htmlheadWithBoder = `<div style="padding: 5px 5px 5px 10px;width: 50%;border-right: 1px solid rgb(197, 197, 197);min-height: 190px;">
    <table>
      <thead>
        <tr>
          <th>DATE(S)</th>
          <th style="padding: 0 10px 0 10px;">DEWORMING</th>
        </tr>
      </thead>
      <tbody>`
    
    let htmlheadWithoutBoder = `<div style="padding: 5px 5px 5px 10px;width: 50%;min-height: 190px;">
    <table>
      <thead>
        <tr>
          <th>DATE(S)</th>
          <th style="padding: 0 10px 0 10px;">DEWORMING</th>
        </tr>
      </thead>
      <tbody>`    

      

    let htmlbot = `</tbody>
        </table>   
      </div>`

    let deworm = mRecord.MedicalRecordMedications.filter(
      (i) => {
        return i.Medication.type === "deworm";
      }
    )

    if(deworm.length <= 10){
      html += htmlheadWithBoder 
      deworm.map((item, index) => (
        html  += `<tr>
          <td>
            ${item.date}
          </td>
          <td style="padding: 0 10px 0 10px;">
            ${item.Medication.name} - ${item.more_info}
          </td>
          
        </tr>`
      ))
      html += htmlbot;

      html += htmlheadWithoutBoder;
      html += htmlbot;
    }else{

      
      let i = 1;
      let continues = 1;
      let temp_html = ``;

      deworm.map((item, index) => {
        if(i == 1){
          if(continues == 1){
            temp_html += htmlheadWithBoder;
          }else{
            temp_html += htmlheadWithoutBoder;
          }
        }

        temp_html  += `<tr>
          <td>
            ${item.date}
          </td>
          <td style="padding: 0 10px 0 10px;">
            ${item.Medication.name} - ${item.more_info}
          </td>
        </tr>`

        if(i == 10 || (index+1) == deworm.length){
          temp_html += htmlbot;
          html += temp_html
          temp_html = "";
          i = 1;
          
        }else{
          i++;
        }

        continues++;

      });

    }

    return html;
  }

  render() {
    const { mRecord, bannerDone, signatureDone } = this.state;
    const { petShop } = this.props;
    let sex = mRecord.sex || " ";
    sex = sex.substring(0, 1);
    let vaccinations = this.formatVaccinations(mRecord);
    let treatments = this.formatTreatments(mRecord);
    let filename = this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : mRecord.Contract.Customer.firstname + " " +mRecord.Contract.Customer.lastname : mRecord.PetShop ? mRecord.PetShop.title : "-";
    filename = mRecord.pet_id +"-"+ filename.split(' ').join('-').split('.').join('')+"-waybill"
    let breedtypeandsex = mRecord.breed_type + " ("+sex+")";
    return (
      <div style={{ position: "absolute", top: "0px", left: "-2500px" }}>
        <PDFExport
          paperSize="A4"
          forceProxy={true}
          proxyURL={BASE_URL + "/public/pet_shop/proxyDownload"}
          keepTogether=".sign"
          fileName={filename}
          proxyTarget="_blank"
          title=""
          subject=""
          keywords=""
          landscape={false}
          forcePageBreak=".page-break"
          ref={(component) => (this.resume = component)}
          margin="0.5cm"
        >
          
          <div className=""  style={{width:"565px", margin: "0 auto"}}>
            {/* 1st Page  */}
            {this.props.envelope ? 
            <div style={{width:"100%",marginBottom:"10px",marginTop:"10px"}}>

                <div style={{marginTop:"50px"}}>
                  {/* headding */}
                  <div>
                    <span style={{ width: "10%", display: "block", marginLeft: "50px"}}>
                      <img
                          src="../assets/app/media/img/icons/info-ico-no-back.png"
                          className="ico"
                          style={{marginTop: "5px"}}
                      />
                    </span>
                    <div style={{width: "90%", marginLeft: "100px"}}>
                      <h1 style={{display: "block", fontSize: "30px", borderBottom: "3px #000 solid", width: "22%", fontWeight: "bold"}}>Breeder:</h1>
                      <h3 style={{fontSize: "20px"}}>{ mRecord.Breeder.breeder}</h3>
                      <p style={{fontSize: "15px", marginBottom: 0}} dangerouslySetInnerHTML={{__html: mRecord.Breeder.addressLine1}}></p>
                      <p style={{fontSize: "15px"}} dangerouslySetInnerHTML={{__html: mRecord.Breeder.addressLine2}}></p>
                    </div>
                    
                  </div>
                  
                </div>

                <div style={{marginTop:"50px", paddingBottom: "50px", borderBottom: "1px #000 solid"}}>
                  {/* headding */}
                  <div>
                    <span style={{ width: "10%", display: "block", marginLeft: "50px"}}>
                      <img
                          src="../assets/app/media/img/icons/pet-ico-no-back.png"
                          className="ico"
                          style={{marginTop: "5px"}}
                      />
                    </span>
                    <div style={{width: "90%", marginLeft: "100px"}}>
                      <h1 style={{display: "block", fontSize: "30px", borderBottom: "3px #000 solid", width: "20%", fontWeight: "bold"}}>Puppy:</h1>
                      <h3 style={{fontSize: "20px"}}>{mRecord.breed_type} ({sex})</h3>
                      <h3 style={{fontSize: "20px"}}>ID : {mRecord.pet_id}</h3>
                    </div>
                    
                  </div>
                  
                </div>

                <div style={{marginTop:"50px", paddingBottom: "50px", borderBottom: "1px #000 solid"}}>
                  {/* headding */}
                  <div>
                    <span style={{ width: "10%", display: "block", marginLeft: "50px"}}>
                      <img
                          src="../assets/app/media/img/icons/customer-ico.png"
                          className="ico"
                          style={{marginTop: "5px"}}
                      />
                    </span>
                    <div style={{width: "90%", marginLeft: "100px"}}>
                      <h1 style={{display: "block", fontSize: "30px", borderBottom: "3px #000 solid", width: "30%", fontWeight: "bold"}}>Customer:</h1>
                      <h3 style={{fontSize: "20px"}}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : <div>{mRecord.Contract.Customer.firstname} {mRecord.Contract.Customer.lastname}</div> : mRecord.PetShop ? mRecord.PetShop.title : "-"}</h3>
                      <p style={{fontSize: "15px"}}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? <div dangerouslySetInnerHTML={{__html: mRecord.PetShop.address}}></div>  : "-" : <div>{mRecord.Contract.Customer.address} {mRecord.Contract.Customer.address_opt}</div> : mRecord.PetShop ? <div dangerouslySetInnerHTML={{__html: mRecord.PetShop.address}}></div> : "-"}{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? formatPhoneNumber(mRecord.PetShop.phone_number) : "-" : formatPhoneNumber(mRecord.Contract.Customer.phone_primary) : mRecord.PetShop ? formatPhoneNumber(mRecord.PetShop.phone_number) : "-"}</p>
                    </div>
                    
                  </div>
                  
                </div>


                <div style={{width: "157px",height: "42.75px", marginTop:"75px", position:"relative", left:"36%", right: "75%"}}>
                    <div style={{marginTop:"10px", borderWidth:"1px",borderStyle: "dashed", fontSize: "8px", width: "100%"}}>
                      <div style={{ padding: "2px",float : "left",borderRight: "1px #000 solid",borderBottom: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                        <strong style={{ fontSize: "7px", lineHeight: 1 }}>BREEDER</strong>
                        <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{ mRecord.Breeder.breeder}</p>
                        {/* <p style={{ fontSize: "100%", lineHeight: 1.4, textTransform: "uppercase" }}>{ mRecord.Breeder.breeder}</p> */}
                      </div>

                      <div style={{margin: 0,padding: "2px",float : "left", borderBottom: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                        <strong style={{ fontSize: "7px", lineHeight: 1 }}>CUSTOMER</strong>
                        <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : <div>{mRecord.Contract.Customer.firstname} {mRecord.Contract.Customer.lastname}</div> : mRecord.PetShop ? mRecord.PetShop.title : "-"}</p>
                        {/* <p className="customer_name_cls" style={{ fontSize: "100%", lineHeight: 1.4, textTransform: "uppercase" }}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : <div>{mRecord.Contract.Customer.firstname} {mRecord.Contract.Customer.lastname}</div> : mRecord.PetShop ? mRecord.PetShop.title : "-"}</p> */}
                      </div>
                      <div style={{clear:'both'}}></div>
                      <div style={{margin: 0,padding: "2px",float : "left", borderRight: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                        <strong style={{ fontSize: "7px", lineHeight: 1 }}>BREED</strong>
                        <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{ mRecord.Breed.breed_type}</p>
                      </div>

                      <div style={{margin: 0,padding: "2px",float : "left", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                        <strong style={{ fontSize: "7px", lineHeight: 1 }}>PUPPY-ID</strong>
                        <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>ID: { mRecord.pet_id}</p>
                      </div>

                      <div style={{clear:'both'}}></div>

                    </div>
                </div>
   
            </div>

            : ""}
            {/* 2nd page */}
            {this.props.waybill && this.props.envelope ? <div className="page-break"></div> : ""}
            
            {this.props.waybill ?
            <div className="second_page_waybill">
              <div className="" style={{width:"100%",marginBottom:"5px"}}>
                <img
                  src="../assets/app/media/img/pdf/k9pet.png"
                  style={{width:"175px",height:"100px", position: "relative", left: "7px"}}
                />
                <img
                  src="../assets/app/media/img/pdf/puppyex.png"
                  style={{width:"190px",height:"70px",marginTop:"20px",position: "relative", left: "-3px"}}
                />
                <img
                  src="../assets/app/media/img/pdf/addresspet.png"
                  style={{width:"180px",height:"100px",marginLeft:"20px", position: "relative", left: "-9px"}}
                />
              </div>
              <div style={{display:"inline-flex"}}>
                <div style={{marginLeft:"0px",marginRight:"0px",width: "50%"}}>
                  <div className="col-md-12" style={{display:"inline-flex",border:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px", height: "41px"}}>
                  <div className="col-md-12" >
                    <div style={{fontSize:"7px"}}>From Shipper/Company Name</div>
                    <div style={{fontSize:"10px",fontWeight:"700"}}>{ mRecord.Breeder.breeder}</div>
                  </div>
                </div>
                  <div className="col-md-12" style={{border:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px",marginTop:"0px",borderTop:"none", height: "60px"}}>
                    <div className="col-md-12">
                      <div style={{fontSize:"7px"}}>Address</div>
                      <div style={{fontSize:"10px"}}>{ mRecord.Breeder.addressLine1 }</div>
                    </div>
                </div>
                  <div className="col-md-12" style={{border:"2px solid black",padding:"2px",marginLeft:"0px",marginRight:"0px",borderTop:"none", height: "41px", paddingTop:0}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>City</div>
                      <div style={{fontSize:"10px"}}>{ mRecord.Breeder.addressCity }</div>
                    </div>
                    <div className="col-md-3">
                      <div style={{fontSize:"7px"}}>State</div>
                      <div style={{fontSize:"10px"}}>{mRecord.Breeder.addressState }</div>
                    </div>
                    <div className="col-md-3">
                      <div style={{fontSize:"7px"}}>Zip code</div>
                      <div style={{fontSize:"10px"}}>{ mRecord.Breeder.addressPostalCode }</div>
                    </div>
                  </div>
                
                </div>
                  <div className="col-md-12" style={{ border:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px",borderTop:"none", paddingTop: "0px", height: "41px"}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>Shipper Telephone</div>
                      <div style={{fontSize:"10px"}}>917-348-5130</div>
                    </div>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>Shipper Emergency Tel</div>
                      <div style={{fontSize:"10px"}}> - </div>
                    </div>
                  </div>
                  
                </div>
                  <div className="col-md-12" style={{border:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px",borderTop:"none", height: "60px"}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-8">
                      <div style={{fontSize:"7px"}}>Shipper Signature</div>
                      {mRecord.Breeder.signature_path != null?
                        <img
                        src={signatureDone}
                        style={{maxWidth:"80px"}}
                        className="col-md-4"
                        />
                      : <div style={{fontSize:"10px"}}>
                          <img
                            src="../assets/app/media/img/bg/transparant.png"
                            style={{maxWidth:"80px"}}
                            className="col-md-4"
                            />
                        </div>}
                    </div>
                    <div className="col-md-4">
                      <div style={{fontSize:"7px"}}>USDA#</div>
                      <div style={{fontSize:"10px",fontWeight:"700"}}>{ mRecord.Breeder.usda_no }</div>
                    </div>
                  </div>
                </div>

            
                  <div className="col-md-12" style={{fontSize:"7px",border:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px",marginTop:"5px", height: "207px"}}>
                  <div style={{fontSize:"7px"}}>Shipper certmes that the particulars on the face hereof are correct and that insofar as any part of the consignment 
                      contains dangerous goods, such part is properly described by name and is in proper condition for carriage by truck according to the applicable Dangerous Goods Regulations.
                  </div><br/>
                  <div style={{fontSize:"7px"}}>____________ date of last Feed/Watering ______ time of last Feed/Watering</div>
                  <div style={{fontSize:"7px"}}>Shipper certifies that animals have been fed/watered by shipper within 4 hours of transport</div><br/>
                  <div style={{fontSize:"7px", textAlign: "center"}}>
                    {mRecord.Breeder.signature_path != null?
                          <img
                          src={signatureDone}
                          style={{maxWidth:"80px"}}
                          className="col-md-4"
                          />
                        : <div style={{fontSize:"10px"}}> <img
                            src="../assets/app/media/img/bg/transparant.png"
                            style={{maxWidth:"80px"}}
                            className="col-md-4"
                            /></div>}

                        
                    
                  </div>
                  <div style={{fontSize:"7px",textAlign:"center",marginBottom:"5px"}}>Signature of Shipper Here & Initial Applicable Box Below </div>
                  <div className="col-md-12" style={{display:"inline-flex",marginBottom:"10px",fontSize:"4px"}}>
                    <div className="col-md-6" style={{display:"inline-flex"}}><div style={{width: "7px",border:"1px solid black",padding:"5px",marginRight:"5px", position:"relative"}}>
                        <img
                          src="../assets/app/media/img/check.png"
                          style={{width:"8px", height: "8px", zIndex: 10000, position: "absolute", top: "4px", left: "1px"}}
                        /></div>This Shipment does not contain dangerous goods regulated in truck transport</div>
                    <div className="col-md-6" style={{display:"inline-flex"}}><div style={{width: "7px",border:"1px solid black",padding:"5px",marginRight:"5px"}}></div>This Shipment does contain dangerous goods regulated in truck transport</div>
                  </div>
                  <br/>
                  <div style={{fontSize:"5px",marginBottom:"5px"}}>EXECUTED ON:</div>
                  <div style={{fontSize:"7px"}}>_______________________________________ ____________________________</div>
                  <div style={{fontSize:"5px",marginBottom:"5px"}}><span style={{marginRight:"41px"}}>(Date)</span><span style={{marginRight:"10px"}}>(Time)</span><span style={{marginRight:"10px"}}>At</span><span style={{marginRight:"10px"}}>(Place)</span><span style={{marginLeft:"15px"}}>Signature of Issuing Carrier or its Agent</span></div>
                
                </div>

                </div>

              
                <div style={{marginRight:"0px",width: "50%"}}>
                <div className="col-md-12" style={{display:"inline-flex",borderRight:"2px solid black", borderTop:"2px solid black",padding:"3px",marginLeft:"0px",marginRight:"0px", height: "39px"}}>
                  <div className="col-md-12" >
                    <div style={{fontSize:"7px"}}>To: Consignee's Name</div>
                    <div style={{fontSize:"10px",fontWeight:"700"}}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : <div>{mRecord.Contract.Customer.firstname} {mRecord.Contract.Customer.lastname}</div> : mRecord.PetShop ? mRecord.PetShop.title : "-"}</div>
                  </div>
                </div>
                <div className="col-md-12" style={{padding:"3px",marginLeft:"0px",marginRight:"0px",borderRight:"2px solid black", borderTop:"2px solid black", height: "60px"}}>
                    <div className="col-md-12">
                      <div style={{fontSize:"7px"}}>Address</div>
                      <div style={{fontSize:"10px"}}><div style={{fontSize:"10px"}}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? <div dangerouslySetInnerHTML={{ __html: mRecord.PetShop.address }}></div> : "-" : <div>{mRecord.Contract.Customer.address} {mRecord.Contract.Customer.address_opt}</div> : mRecord.PetShop ? <div dangerouslySetInnerHTML={{ __html: mRecord.PetShop.address }}></div>   : "-"}</div></div>
                    </div>
                </div>
                <div className="col-md-12" style={{padding:"2px",marginLeft:"0px",marginRight:"0px",borderRight:"2px solid black", borderTop:"2px solid black", height: "41px"}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>City</div>
                      <div style={{fontSize:"10px"}}>{ this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.city : "-" : mRecord.Contract.Customer.city : mRecord.PetShop ? mRecord.PetShop.city : "-"}</div>
                    </div>
                    <div className="col-md-3">
                      <div style={{fontSize:"7px"}}>State</div>
                      <div style={{fontSize:"10px"}}>{ this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.state : "-" : mRecord.Contract.Customer.state : mRecord.PetShop ? mRecord.PetShop.state : "-"}</div>
                    </div>
                    <div className="col-md-3">
                      <div style={{fontSize:"7px"}}>Zip code</div>
                      <div style={{fontSize:"10px"}}>{ this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.zipcode : "-" : mRecord.Contract.Customer.zip_code : mRecord.PetShop ? mRecord.PetShop.zipcode : "-"}</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" style={{padding:"3px",marginLeft:"0px",marginRight:"0px",borderRight:"2px solid black", borderTop:"2px solid black", height: "41px"}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>Consignee Telephone</div>
                      <div style={{fontSize:"10px"}}>{this.props.type == 'customer' ? mRecord.Contract == null ? mRecord.PetShop ? formatPhoneNumber(mRecord.PetShop.phone_number) : "-" : formatPhoneNumber(mRecord.Contract.Customer.phone_primary) : mRecord.PetShop ? formatPhoneNumber(mRecord.PetShop.phone_number) : "-"}</div>
                    </div>
                    <div className="col-md-6">
                      <div style={{fontSize:"7px"}}>Regular Vet Tel</div>
                      <div style={{fontSize:"10px"}}>{ mRecord.Contract == null ? "-" : mRecord.Contract.Customer.phone_secondary}</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" style={{padding:"3px",marginLeft:"0px",marginRight:"0px", height: "53px", borderRight:"2px solid black", borderTop:"2px solid black", borderBottom:"2px solid black", height: "62px"}}>
                  <div style={{display:"inline-flex",width:"100%"}}>
                    <div className="col-md-12">
                      <div style={{fontSize:"7px"}}>Destination</div>
                      <div style={{fontSize:"10px"}}>-</div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12" style={{fontSize:"7px",padding:"3px",marginLeft:"0px",marginRight:"0px",marginTop:"5px",height: "174px", borderRight:"2px solid black", borderTop:"2px solid black", borderBottom:"2px solid black", height: "207px"}}>
                  <div style={{marginTop:"5px",padding:"3px",marginBottom:"5px"}}>SPECIAL INSTRUCTIONS:
                  </div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <div style={{fontSize:"7px",marginBottom:"5px"}}>_____________________________________________________________________</div>
                  <br/>
                  <div style={{padding:"3px",fontSize:"8px",textAlign:"center",marginBottom:"3px"}}>3 Copies of the Health Certificate must accompany shipment. Please contact us <span style={{fontStyle:"italic"}}>BEFORE MONDAY</span>&nbsp;&nbsp;to book your animal(s) for Transport
                  </div>
                
                </div>

              </div>
              </div>

              <div style={{marginBottom:"10px",marginTop:"0px",width: "100%"}}>
                <table style={{border:"1px solid black",width:"100%"}}>
                <tr style={{border:"1px solid black"}}>
                  <th style={{border:"1px solid black",textAlign:"center",backgroundColor:"black",color:"white",fontSize:"9px"}}>COLLECTION OF MONEY</th>
                </tr>
                <tr style={{border:"1px solid black"}}>
                  <td>
                      <div className="col-md-12" style={{display:"inline-flex",width:"100%",fontSize:"5px",marginTop:"10px", position: "relative"}}>
                        <h5 style={{position: "absolute", top: "10px", left: "31%",right: "69%", width: "100%", fontSize: "11px"}}>(PAID IN FULL)</h5>
                        
                        <div className="col-md-5">
                          <div className="col-md-12" style={{display:"inline-flex"}}><div>___________</div>OPEN</div><br/>
                          <div className="col-md-12" style={{display:"inline-flex",marginTop:"5px"}}><div>___________</div>C.O.D. - COMPANY CHECK</div><br/>
                          <div className="col-md-12" style={{display:"inline-flex",marginTop:"5px"}}><div>___________</div>C.O.D. - EZ Pet Pay</div>
                        </div>
                        <div className="col-md-7">
                          <div className="col-md-12" style={{display:"inline-flex"}}><div>__________________</div>STORE CREDIT CARD / DEBIT CARD </div><br/>
                          <div className="col-md-12" style={{display:"inline-flex",marginTop:"5px"}}><div>__________________</div>TOTAL TO BE COLLECTED (Write N/A for Open Account)</div><br/>
                          <div className="col-md-12" style={{display:"inline-flex",marginTop:"5px"}}><div>__________________</div>TOTAL AMOUNT COLLECTED (Write N/A for Open Account)</div>
                        </div>
                      </div>

                      <div className="col-md-12" style={{width:"100%",fontSize:"7px",textAlign:"center",marginBottom:"10px",marginTop:"10px",fontStyle:"italic"}}>
                        <div>(SHIPPER &nbsp;&nbsp;<strong>MUST</strong> INITIAL BY METHOD OF PAYMENT)</div>
                      </div>
                  </td>
                </tr>
          
              </table>

              </div>

              <div style={{width:"100%",marginBottom:"20px"}}>
                <table style={{border:"1px solid black",width:"100%",fontSize:"7px"}}>
                  <thead>
                    <tr style={{border:"1px solid black",backgroundColor:"black",color:"white"}}>
                      {/* <th style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>LOAD-IN</th> */}
                      <th style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>PET I.D. NO</th>
                      <th style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>MICRO-CHIP. NO.</th>
                      <th style={{border:"1px solid black",textAlign:"center",padding:"3px", width: "300px"}}>BREED </th>
                      {/* <th style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>LOAD-OUT</th> */}
                      <th style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>STORE SIGNATURE</th>
                    </tr>
                  </thead>
                  <tbody style={{fontSize:"9px"}}>
                    <tr style={{border:"1px solid black"}}>
                      {/* <td style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>-</td> */}
                      <td style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>{mRecord.pet_id}</td>
                      <td style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>{mRecord.micro_chip}</td>
                      <td width="110" style={{border:"1px solid black",textAlign:"center",padding:"3px", width: "300px"}}>{breedtypeandsex}</td>
                      {/* <td style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>-</td> */}
                      <td style={{border:"1px solid black",textAlign:"center",padding:"3px"}}>-</td>
                    </tr>
                  </tbody>          
                </table>

              </div>
              
              <div className="col-md-12" style={{marginTop:"10px"}}>
                <div style={{fontSize:"7px"}}>________________________________________________________________________________________________&nbsp;&nbsp;______________________________________________</div>
                <div style={{fontSize:"5px",marginBottom:"5px"}}><span style={{marginRight:"100px"}}>(Date)</span><span style={{marginRight:"30px"}}>(Time)</span><span style={{marginRight:"30px"}}>At</span><span style={{marginRight:"30px"}}>(Place)</span><span style={{marginLeft:"115px"}}>Signature of Issuing Carrier or its Agent</span></div>
              </div>

              <div className="col-md-12" style={{width:"100%",fontSize:"9px",textAlign:"center",marginBottom:"10px",marginTop:"20px",fontStyle:"italic"}}>
                <div><strong>Licensed & Insured  <span style={{marginLeft:"20px"}}>Local & Long Distance</span></strong></div>
              </div>
            </div>
            : ""}        
            {/* 3rd page */}
            {this.props.medical_record && (this.props.waybill || this.props.envelope) ? <div className="page-break"></div> : ""}
            {this.props.medical_record ?
            <div style={{textTransform: "uppercase"}}>        
              <div className="header-wrapper">
                <div
                  className="logo-section"
                  style={{ width: "108px", float: "left", marginTop: "12px" }}
                >
                  <img style={{ width: "100%" }} src={bannerDone} />
                </div>
                <div
                  className="brand-section"
                  style={{
                    width: "271px",
                    float: "right",
                    textAlign: "center",
                    paddingTop: "8px",
                    fontSize: "24px",
                    marginRight: "1px"
                  }}
                >
                  PET MEDICAL RECORD
                  <div
                    className="info-section"
                    style={{ fontSize: "10px", float: "right", width: "100%", position: "relative", top: "-5px" }}
                  >
                    <div className="arrival-info" style={{ float: "left", marginLeft: "3px" }}>
                      ARRIVAL:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {mRecord.arrival_date}
                      </span>
                    </div>
                    <div className="pet-info" style={{ float: "right", marginRight: "1px" }}>
                      PET ID#:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {mRecord.pet_id}
                      </span>
                    </div>
                  </div>
                </div>
              </div> 
              
              <div style={{width: "100%", display: "inline-flex", marginTop: "13px", fontSize: "10px"}}>     

                <div style={{background: "#E1E1E1", width: "48%", borderRadius: "13px", paddingBottom: "10px"}}>
                  <div style={{borderBottom: "1px #C5C5C5 solid", width:"100%", padding: "10px 10px 7px 10px", position: "relative"}}>
                    <span><strong>PET</strong></span>
                    <img src="../assets/app/media/img/icons/icon1.png" alt="" style={{width: "47px", position: "absolute", top: "-3px", right: "-7px"}}/>
                  </div>
                  <div style={{padding: "5px 5px 5px 10px", width: "100%"}}>
                      <div><strong>SEX: </strong> { mRecord.sex}</div>
                      <div><strong>BREED: </strong> { mRecord.Breed.breed_type}</div>
                      <div><strong>COLOR: </strong> {mRecord.color_markings}</div>
                      <div><strong>DATE OF BIRTH: </strong> {mRecord.date_of_birth}</div>
                      <div><strong>MICROCHIP #: </strong> {mRecord.micro_chip}</div>
                      <div><strong>CROSS BREED: </strong> {mRecord.cross_breed}</div>
                  </div>   
                </div> 

                <div style={{background: "#E1E1E1", width: "48%", marginLeft: "23px", borderRadius: "13px", paddingBottom: "10px"}}>
                  <div style={{borderBottom: "1px #C5C5C5 solid", width:"100%", padding: "10px 10px 7px 10px", position: "relative"}}>
                    <span><strong>REGISTRATION</strong></span>
                    <img src="../assets/app/media/img/icons/icon2.png" alt="" style={{width: "48px", position: "absolute", top: "-3px", right: "-8px"}}/>
                  </div>
                  <div style={{padding: "5px 5px 5px 10px", width: "100%"}}>
                      <div><strong>REGISTRATION TYPE: </strong> {mRecord.registration_type || ""}</div>
                      <div><strong>SIRE: </strong> {mRecord.sire || ""}</div>
                      <div><strong>SIRE NO: </strong> {mRecord.dam_number || ""}</div>
                      <div><strong>DAM: </strong> {mRecord.dam || ""}</div>
                      <div><strong>DAM NO: </strong> {mRecord.sire_number || ""}</div>
                  </div>   
                </div>    
              </div>
            
              <div style={{width: "100%",minHeight: "90px", display: "inline-flex", marginTop: "22px", fontSize: "10px", }}>
                <div style={{background: "#E1E1E1", width: "100%", borderRadius: "13px", paddingBottom: "10px"}}>
                  <div style={{borderBottom: "1px #C5C5C5 solid", width:"100%", padding: "10px 10px 7px 10px", position: "relative"}}>
                    <span><strong>BREEDER</strong></span>
                    <img src="../assets/app/media/img/icons/icon3.png" alt="" style={{width: "47px", position: "absolute", top: "-3px", right: "-6px"}}/>
                  </div>
                  <div style={{padding: "5px 5px 5px 10px", width: "100%"}}>
                      <div><strong>NAME: </strong> {mRecord.Breeder.breeder || ""}</div>
                      <div><strong>BREEDER ADDRESS: </strong> 
                        <span style={{ fontWeight: "normal" }}>
                          {mRecord.Breeder && mRecord.Breeder.addressLine1
                            ? mRecord.Breeder.addressLine1
                            : "-"}
                          {mRecord.Breeder && mRecord.Breeder.addressLine2
                            ? ", " + mRecord.Breeder.addressLine2
                            : ""}
                          {mRecord.Breeder && mRecord.Breeder.addressCity
                            ? ", " + mRecord.Breeder.addressCity
                            : ""}
                          {mRecord.Breeder && mRecord.Breeder.addressState
                            ? ", " + mRecord.Breeder.addressState
                            : ""}
                          {mRecord.Breeder && mRecord.Breeder.addressPostalCode
                            ? ", " + mRecord.Breeder.addressPostalCode
                            : ""}
                          {mRecord.Breeder && mRecord.Breeder.addressCountry
                            ? ", " + mRecord.Breeder.addressCountry
                            : ""}
                        </span>
                      </div>
                  </div>   
                </div>    
              </div>   

              <div style={{width: "100%",minHeight: "190px", display: "inline-flex", marginTop: "22px", fontSize: "10px"}}>
                <div style={{background: "#E1E1E1", width: "100%", borderRadius: "13px"}}>
                  <div style={{borderBottom: "1px #C5C5C5 solid", width:"100%", padding: "10px 10px 7px 10px", position: "relative"}}>
                    <span><strong>VACCINATIONS</strong></span>
                    <img src="../assets/app/media/img/icons/icon4.png" alt="" style={{width: "49px", position: "absolute", top: "-3px", right: "-8px"}}/>
                  </div>
                  <div style={{width: "100%", display: "inline-flex"}}>
                      <div style={{width: "100%", display: "inline-flex", fontSize: "8px"}} dangerouslySetInnerHTML={{ __html: vaccinations }}></div>
                  </div>
                    
                </div>    
              </div> 

              <div style={{width: "100%", minHeight: "190px", display: "inline-flex", marginTop: "22px", fontSize: "10px", marginBottom: "30px"}}>
                <div style={{background: "#E1E1E1", width: "100%", borderRadius: "13px"}}>
                  <div style={{borderBottom: "1px #C5C5C5 solid", width:"100%", padding: "10px 10px 7px 10px", position: "relative"}}>
                    <span><strong>TREATMENTS</strong></span>
                    <img src="../assets/app/media/img/icons/icon5.png" alt="" style={{width: "48px", position: "absolute", top: "-3px", right: "-7px"}}/>
                  </div>
                  <div style={{width: "100%", display: "inline-flex"}}>
                      <div style={{width: "100%", display: "inline-flex", fontSize: "8px"}} dangerouslySetInnerHTML={{ __html: treatments }}></div>
                  </div>
                    
                </div>    
              </div>    

              <br></br>
            
            </div>
            : ""}              
          </div>
        </PDFExport>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  showMedicalRecord: (id) => {
    dispatch(showMedicalRecord(id));
  },
  pdfGeneratorStatus: (status) => {
    dispatch(pdfGeneratorStatus(status));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DOPDFView)
);
